function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import AbstractInput from '../AbstractInput';
import { classNamesFor } from '../utils/classNames';
import AbstractCheckbox from './AbstractCheckbox';
var cx;
/**
 * The Checkbox component provides a stylable alternative
 * to the HTML5 element of the same name. This checkbox is implemented as a controlled
 * component which means that state is managed outside of the component.
 *
 * - [React controlled inputs](https://reactjs.org/docs/forms.html#controlled-components)
 * - [MDN docs for checkbox](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/checkbox)
 *
 * ## Related Components
 * - [Radio](../Radio/README.md)
 * - [RadioGroup](../RadioGroup/README.md)
 *
 * ## Usage
 *
 * ```jsx
 * <Checkbox
 *   id="my-checkbox"
 *   variant="toggle"
 *   name="isLiked"
 *   value="yes"
 *   checked={myCheckboxState}
 *   onChange={this.handleMyCheckboxState}
 * />
 * ```
 *
 * If an id is not provided one will be computed so all internal labels are properly
 * associated with the underlying input element
 *
 * Checkboxes can also wrap arbitrary content making them checkboxes with the children render prop!
 *
 * ```jsx
 * <Checkbox
 *   id="my-checkbox"
 *   variant="content"
 *   label="My checkbox"
 *   name="isLiked"
 *   value="yes"
 *   checked={myCheckboxState}
 *   onChange={this.handleMyCheckboxState}
 * >
 *   {(checked) => (
 *     <>
 *       <Player {...props} />
 *       {checked && <Icon type="check" />}
 *     </>
 *   )}
 * </Checkbox>
 * ```
 *
 * Or with basic children prop
 *
 * ```jsx
 * <Checkbox
 *   id="my-checkbox"
 *   variant="content"
 *   name="isLiked"
 *   value="yes"
 *   checked={myCheckboxState}
 *   onChange={this.handleMyCheckboxState}
 * >
 *    <Player {...props} />
 *    {myCheckboxState && <Icon type="check" />}
 * </Checkbox>
 * ```
 *
 * ## Props
 */

var Checkbox = /*#__PURE__*/function (_AbstractInput) {
  _inherits(Checkbox, _AbstractInput);

  var _super = _createSuper(Checkbox);

  function Checkbox() {
    _classCallCheck(this, Checkbox);

    return _super.apply(this, arguments);
  }

  _createClass(Checkbox, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          qa = _this$props.qa,
          id = _this$props.id,
          variant = _this$props.variant,
          ctaType = _this$props.ctaType,
          size = _this$props.size,
          className = _this$props.className,
          checked = _this$props.checked,
          disabled = _this$props.disabled,
          children = _this$props.children,
          node = _this$props.node;
      var isFocused = this.state.isFocused;
      return /*#__PURE__*/React.createElement(AbstractCheckbox, _extends({}, this.props, {
        qa: qa,
        id: this.id || id,
        type: "checkbox",
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        ref: node,
        styleHooks: Checkbox.getClassName({
          ctaType: ctaType,
          size: size,
          variant: variant,
          className: className,
          checked: checked,
          disabled: disabled,
          isFocused: isFocused,
          children: children
        })
      }));
    }
  }]);

  return Checkbox;
}(AbstractInput);

_defineProperty(Checkbox, "getClassName", function (props) {
  return AbstractCheckbox.getClassName(cx, 'checkbox')(props);
});

_defineProperty(Checkbox, "useClassNames", function (classNames) {
  Checkbox.classNames = classNames;
});

Checkbox.defaultProps = {
  qa: '',
  autoFocusOnSelected: false,
  id: null,
  checked: false,
  disabled: false,
  className: '',
  variant: 'standard',
  size: 'medium',
  ctaType: '',
  name: '',
  node: null,
  value: '',
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  children: null
};
Checkbox.propTypes = {
  /**
   * QA selector attribute used to target important elements for test validation
   */
  qa: PropTypes.string,

  /**
   * Whether the selected radio should be focused on mount
   */
  autoFocusOnSelected: PropTypes.bool,

  /**
   * Render prop to render content as a checkbox. function will receive
   * the internal state of the checkbox (whether it was checked or not)
   */
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),

  /**
   * Passing an id is preferred but if not passed an id will be generated
   * to ensure all labels can be correctly associated with the checkbox
   */
  id: PropTypes.string,

  /**
   * Whether the checkbox is initially checked
   */
  checked: PropTypes.bool,

  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * The presentational variant to render
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(['standard', 'text-list', 'text-list-2', 'toggle', 'content', 'quick-action']), PropTypes.string]),

  /**
   * The size of the quick action button
   */
  size: PropTypes.oneOf(['small', 'medium', 'large']),

  /**
   * The type of button in design language
   */
  ctaType: PropTypes.oneOf(['', 'primary', 'secondary', 'alt-secondary', 'purchase']),

  /**
   * The name of the value to be sent on change
   */
  name: PropTypes.string,

  /**
   * forwarded ref to attach to the checkbox element
   */
  node: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),

  /**
   * Whether the checkbox control is disabled or not
   */
  disabled: PropTypes.bool,

  /**
   * The value of the associated with the checked state
   */
  value: PropTypes.string,

  /**
   * The spec id identifying the interaction
   */
  trackClick: PropTypes.string,

  /**
   * Serialized json data of context specific telemetry data
   */
  telemetryMeta: PropTypes.string,

  /**
   * event callback to be called when the checked state changes
   */
  onChange: PropTypes.func,

  /**
   * event callback to be called when the checkbox is focused
   */
  onFocus: PropTypes.func,

  /**
   * event callback to be called when the checkbox is blurred
   */
  onBlur: PropTypes.func
};
cx = classNamesFor(Checkbox);
export default Checkbox;